import { StrategyIcon } from './StrategyIcon';

/**
 * author: Michael Richins
 * id 854C16E8-58EA-49E3-B1AE-7EC84B313005
 * name strategy
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/strategy.svg
 * tags
 * - Sport 
 */
export const FootballPlayIcon = StrategyIcon;
export default FootballPlayIcon